import React, { useEffect } from 'react';
import { Row, Col, Card, Alert, Image, Tooltip, OverlayTrigger } from 'react-bootstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { getStatus } from './../../../../actions/closeLoop/validation/index';
import Loader from './../../../../utilityComponents/MiniLoader';
import AccordionContents from './../accords/accords';

const check = require('./../../../../images/validation/status-check.png');

function StatusCheck() {
    return (
        <Row style={{ alignItems: 'center', textAlign: 'center' }}>
            <Col lg={8} xs={8}>
                <h2>Status : </h2>
            </Col>
            <Col>
                <Image src={check} style={{ height: "36px", width: "36px" }}/>
            </Col>
        </Row>
    )
}


function Validator(props) {

    useEffect(() => {
        props.fetchStatus(props.queryString);
    }, [])

    return (
        <>
            <Row>
                <Col lg={12} xs={12}>
                    <OverlayTrigger
                        key='top'
                        placement='top'
                        overlay={
                            <Tooltip
                                id="tooltip-top"
                            >
                                <strong>{props.title} Check</strong>
                            </Tooltip>
                        }
                    >
                        <Card border="secondary">
                            <Row style={{ textAlign: "center" }}>
                                <Col xg={12} ls={12}>
                                    <Card.Img variant="top" src={props.icon} style={{ width : '200px', height: '200px' }}/>
                                </Col>
                            </Row>
                            <Card.Body>
                                <Card.Title>{ props.title } Check</Card.Title>
                                <Card.Text>
                                    { Object.keys(props['validation']).length ? (props["validation"][props.queryString]['loading'] ? <Loader /> : props['validation'][props.queryString]['error'] ?
                                      (<Alert key='danger' variant='danger'>
                                          { props['validation'][props.queryString]['error'] }
                                       </Alert>) : <StatusCheck /> ) : undefined}
                                </Card.Text>
                                { Object.keys(props['validation']).length ? (
                                     Array.isArray(props['validation'][props.queryString]['info']) ?
                                     <AccordionContents contents={props['validation'][props.queryString]['info']} /> : undefined
                                 ) : undefined }
                            </Card.Body>
                        </Card>
                    </OverlayTrigger>
                </Col>
            </Row>
        </>
    )
}

Validator.defaultProps = {
    queryString: '',
    icon: ''
}

Validator.propTypes = {
    title: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    queryString: PropTypes.string.isRequired,
    validation: PropTypes.shape({}),
    fetchStatus: PropTypes.func.isRequired
}

const mapStateToProps = (state) => ({
    validation: state.axios
});

const mapDispatchToProps = (dispatch) => ({
    fetchStatus: (payload) => dispatch(getStatus(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Validator);